import React, { useEffect, useState } from "react";
import Logo from "../../helper/svg/LOGO.svg";
import Spoons from "../../helper/svg/spoons.svg";
import Hotels from "../../helper/svg/hotel.svg";
import Mobile from "../../helper/svg/mobile.svg";
import Google from "../../helper/svg/Google.svg";
import { Link, useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import { AiFillEyeInvisible } from "react-icons/ai";
import { FaApple, FaFacebookSquare } from "react-icons/fa";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { login , appleSignIn ,  } from "../../api/auth";
import { useAuth } from "../../context/AuthContext";
import { LoginWithGoogle } from "../../components/SocialLogin/GoogleLogin";
import FacebookLogin from "../../components/SocialLogin/FacebookLogin";
import { AppleLogin } from "../../components/SocialLogin/AppleLogin";
import { useTranslation } from "../../hooks/useTranslation";
import axios from "axios";

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { storeDataToStorage } = useAuth();

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    const token = new URLSearchParams(window.location.search).get("token");
    const error = new URLSearchParams(window.location.search).get("error");

    if (error) {
      toast.error("Apple Sign-In failed. Please try again.");
      navigate("/login");
    }

    else if (code) {
      handleAppleCallback(code);
    }
  }, []);

  const handleAppleCallback = async (code) => {
    try {
      setLoading(true);
      const response = await appleSignIn(code)

      const { token, user } = response.data;
      toast.success("Login successful!");
      storeDataToStorage(user, token);

      if (user.role === "admin") navigate("/admindashboard");
      else if (user.role === "user") navigate("/");
      else if (user.role === "owner") navigate("/ownerdashboard");

      
    } catch (error) {
      console.error("Apple sign-in error:", error);
      toast.error("Apple Sign-In failed. Please try again.");
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: ({ data }) => {
      const { token, user } = data;
      toast.success("Login successful!");
      storeDataToStorage(user, token);

      if (user.role === "admin") navigate("/admindashboard");
      else if (user.role === "user") navigate("/");
      else if (user.role === "owner") navigate("/ownerdashboard");
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message || "Invalid email or password.";
      toast.error(errorMessage);
    },
  });

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    loginMutation.mutate(
      { email, password },
      {
        onSettled: () => setLoading(false),
      }
    );
  };

  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 h-screen">
      {/*  =============== left side =============== */}
      <div className="bg-[#FFF3EF] flex items-center lg:justify-start justify-center">
        <div className="w-full max-w-[650px] lg:ml-auto xl:pr-[175px] lg:pr-[100px]  md:py-[20px] py-[30px] px-[15px]">
          <Link to="/">
            <img src={Logo} alt="logo" className="w-[133px]" />
          </Link>

          
          <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
            <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
              <img src={Spoons} alt="Icon" className="w-[37px]" />
            </div>
            <div className="w-full">
              <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                {t("login").left.tableTitle}
              </h2>
              <p className="text-base leading-[26px]">
                {t("login").left.tableDesc}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
            <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
              <img src={Hotels} alt="Icon" className="w-[37px]" />
            </div>
            <div className="w-full">
              <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                {t("login").left.hotelTitle}
              </h2>
              <p className="text-base leading-[26px]">
                {t("login").left.hotelDesc}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
            <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
              <img src={Mobile} alt="Icon" className="w-[37px]" />
            </div>
            <div className="w-full">
              <h2 className="md:text-[22px] text-lg font-semibold leading-[22px] mb-[7px]">
                {t("login").left.opsTitle}
              </h2>
              <p className="text-base leading-[26px]">
                {t("login").left.opsDesc}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/*  =============== Right side =============== */}
      <div className="flex items-center lg:justify-start justify-center lg:pl-[72px] md:pl-[20px] md:py-[20px] py-[30px] px-[15px] w-full max-w-[100%]">
        <div className="w-full  max-w-[586px]  ">
          <form
            className="w-full md:py-[40px] md:px-[27px] py-[25px] px-[15px] rounded-[10px] form-shadow"
            onSubmit={handleLogin}
          >
            <h2 className="md:text-[30px] text-[22px] font-medium md:mb-[45px] mb-[20px] text-center leading-[21px] placeholder:text-[#858585]">
              {t("login").title}
            </h2>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("login").usernamePlaceholder}
              className="w-full mb-[15px] rounded-[10px] px-[20px] outline-none py-[19px] border border-[#ECEBEB] text-[18px] placeholder:text-[#858585]"
            />

            <div className="relative w-full">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t("login").passwordPlaceholder}
                className="w-full mb-[15px] rounded-[10px] px-[20px] outline-none py-[19px] border border-[#ECEBEB] text-[18px] placeholder:text-[#858585] pr-10"
                required
              />

              {/* Eye Icon always visible */}
              <div
                className="absolute top-[50%] translate-y-[-50%] right-3 flex items-center cursor-pointer text-gray-400"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <AiFillEyeInvisible size={20} />
                ) : (
                  <Eye size={20} />
                )}
              </div>
            </div>

            <div className="text-end">
              <Link className="text-[#16A34A] underline" to="/forgotpassword">
                {t("login").forgotPassword}
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full rounded-[2px] bg-[#4CAF50] text-[18px] text-white font-semibold p-[19px] green-shadow ${
                loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#209b25]"
              }`}
            >
              {loading ? t("login").buttonLoading : t("login").button}
            </button>

            {/* ==========OR=========== */}
            <div className="grid grid-cols-[1fr_auto_1fr] gap-[24px] items-center mt-[25px] mb-[20px] text-lg text-[#949494]">
              <div className="w-full h-[1px] bg-[#ECEBEB]"></div>
              {t("login").or}
              <div className="w-full h-[1px] bg-[#ECEBEB]"></div>
            </div>
            {/* ===============Continue with Google============ */}

            {/* <Link
              className=" flex items-center justify-center gap-[16px] w-full text-center text-[#fff] md:text-[20px] text-[16px] font-medium border  p-[20px] rounded-[10px] mt-[18px] bg-[#000000] hover:bg-[#262323]"
              to="/"
            >
              <FaApple size={20} className="text-[#fff]" />
              {t("login").continueApple}
            </Link> */}
          </form>
          <LoginWithGoogle />

          <FacebookLogin></FacebookLogin>
          <AppleLogin></AppleLogin>
          <p className="text-center text-[18px] text-[#2E2E2E] md:mt-[42px] mt-[20px]">
            {t("login").noAccount}{" "}
            <Link className="text-[#FFA808] underline" to="/register">
              {t("login").signup}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
